<div style="display: flex; flex-direction: column; height: 100%">
    <div [ngStyle]="{paddingTop: '0.1rem'}">
        <p-messages></p-messages>
    </div>
    <div [style.flex-grow]="'1'" [style.overflow-y]="'auto'">
        <div [ngStyle]="{minHeight: _contentMinHeight, paddingTop: '0.5rem', height: '100%'}">
            <app-generic-table
                [data]="_items"
                [cols]="_tableCols"
                [totalCount]="_totalItemCount"
                entityName=""
                [flexHeight]="true"
                [showColumnToggle]="true"
                [showSearch]="false"
                [showRefreshButton]="true"
                [showHelpButton]="false"
                [showNewButton]="false"
                [showTableLoading]="showLoading"
                [showTableError]="showError"
                [defaultPaginatorConfig]="CpmCTaskExecutionApiService.dLogPaginatorConfig"
                [updateBrowerURL]="false"
                [tableLoadingStr]="loadingStr ?? 'Loading'"
                [showPaginator]="true"
                (refreshEvent)="refresh()"
            >
            </app-generic-table>
        </div>
    </div>
    <div class="p-dialog-footer">
        <p-button severity="contrast" icon="pi pi-times" type="button" label="Close" (click)="ref.close()" />
    </div>
</div>
